import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import { Avatar, Container } from "@material-ui/core";

import { SubSystems } from "../../../context/UserContext";


const useStyles = makeStyles((theme) => ({
  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 36,
    fontWeight: 800,
    marginTop: theme.spacing(12),
    color: theme.palette.text.hint,
  },
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 18,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
  },
  items: {
    display: "flex",
    flexDirection: "row",
    margin: theme.spacing(5),
  },
  featureContainer: {
    marginBottom: theme.spacing(2),
  },
  appLogo: {
    backgroundColor: "#000",
    borderRadius: 4,
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
    padding: 5,
    "& img": {
      width: 32,
    }
  },
  appName: {
    color: theme.palette.text.hint,
    fontSize: 24,
    fontWeight: 600,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(5),
  },
  featureLongDesc: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
    lineHeight: 2,
    height: 100,
  },
  subSystemInfo: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    padding: theme.spacing(2),
  },
  subSystemCard: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(1),
    color: theme.palette.text.hint,
  },
  learnMore: {
    marginTop: theme.spacing(2),
    display: "flex",
    paddingLeft: 0,
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    textTransform: "Capitalize",
    borderWidth: 2,
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  buttonLink: {
    marginTop: theme.spacing(5),
  },
  buttonInfoToSystem: {
    margin: "0px 8px",
    borderRadius: 4,
    "&:hover": {
      backgroundColor: theme.palette.text.hint,
      color: "white",
    },
  },
  componentName: {
    width: "36px",
    height: "36px",
    marginTop: "8px",
    marginRight: "8px",
    color: theme.palette.text.hint,
    "&:hover": {
      cursor: "pointer",
      color: theme.palette.primary.main,
    }
  }
}));

export default function Feature3() {
  const classes = useStyles();

  return (
    <Container maxWidth="lg">
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={12}>
            <p className={classes.title}>Venus Data Ecosystem</p>
            <p className={classes.content}>Better Together, Venus Data Stack</p>
          </Grid>
          <Grid item xs={12}>
            <Grid container className={classes.featureContainer}>
              {SubSystems.map(systemInfo => (
                <Grid item xs={6} className={classes.subSystemInfo} key={systemInfo.id}>
                  <Grid container className={classes.subSystemCard}>
                    <Grid item xs={3}>
                      <Avatar className={classes.appLogo} src={systemInfo.icon} />
                    </Grid>
                    <Grid item xs={9}>
                      <p className={classes.appName}>
                        {systemInfo.title}
                      </p>
                      <p className={classes.featureLongDesc}>
                        {systemInfo.longDesc}
                      </p>
                      <p>
                        {systemInfo.subSystemIcons.map(subIconItem => (
                          <span
                            className={classes.componentName}
                            onClick={() => window.open(subIconItem.href)}
                          >
                            {subIconItem.name}
                          </span>
                        ))}
                      </p>
                      <Button
                        endIcon={<ArrowRightAltIcon />}
                        className={classes.learnMore}
                        onClick={() => window.open(systemInfo.link, "_blank")}
                      >
                        Explore {systemInfo.title}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
}